import { useAppContext } from 'hooks/context/useAppContext';

export const useConfig = () => {
  const { config } = useAppContext();

  return config;
};
